import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '../../utils/cn';

const Tabs = TabsPrimitive.Root;

// Figma node: 183:539 - Tabs container with muted background
const TabsList = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'inline-flex h-9 items-center justify-start bg-muted p-[3px] rounded-[10px]',
            className,
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

// Figma node: 183:533 (active), 183:535 (inactive) - Tab triggers
const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'inline-flex items-center justify-center gap-2 px-3 py-1 rounded-[8px] text-sm font-medium whitespace-nowrap transition-all',
            'text-foreground',
            'hover:text-foreground/80',
            'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2',
            'disabled:pointer-events-none disabled:opacity-50',
            // Active state: white background with subtle border, purple text
            'data-[state=active]:bg-background data-[state=active]:text-primary data-[state=active]:border data-[state=active]:border-white/0',
            // Inactive hover state
            'data-[state=inactive]:hover:bg-muted-foreground/10',
            className,
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            'mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2',
            className,
        )}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
